import { useMutation } from "react-query";

import { mutateToPath } from "src/utilities/mutateFn";

export function useAccessTokenMutation(): (
  accessToken: string
) => Promise<void> {
  const { mutateAsync } = useMutation(
    mutateToPath("/api/auth/updateToken", { host: process.env.REACT_APP_URL })
  );

  return async function setToken(accessToken: string) {
    await mutateAsync({ accessToken });
  };
}
